import { motion } from "framer-motion";

const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-gradient-to-b from-secondary/20 to-background px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-6">
              About <span className="text-primary">Zuto</span>
            </h2>
            
            <div className="space-y-6 text-muted-foreground">
              <p className="text-lg">
                Zuto is designed to help students focus on learning instead of frantic note-taking. With advanced AI, Zuto transforms audio content into clean, structured study material—whether it's from live lectures, recorded meetings, or YouTube videos.
              </p>
              
              <p className="text-lg">
                <strong className="text-foreground">Record Live Lectures:</strong> Simply record your lectures and meetings directly in the app. Zuto automatically transcribes the audio and generates comprehensive, well-structured notes in real-time.
              </p>
              
              <p className="text-lg">
                <strong className="text-foreground">YouTube Integration:</strong> Have a YouTube video you want to study? Just paste the link and Zuto will extract the audio, transcribe it, and create detailed notes. Perfect for online courses, tutorials, and educational videos.
              </p>
              
              <p className="text-lg">
                Zuto organizes all your content into three powerful sections: <strong className="text-foreground">Notes</strong> for clear, well-structured summaries; <strong className="text-foreground">Revise</strong> for quick revisiting with highlights and explanations; and <strong className="text-foreground">Q&A</strong> for testing yourself with AI-generated questions.
              </p>
              
              <p className="text-lg">
                Whether you're in the classroom, watching online courses, attending seminars, or preparing for exams, Zuto makes sure knowledge stays with you long after the lecture ends. Zuto doesn't just capture content—it turns any audio source into a personalized study companion that helps you learn, revise, and succeed.
              </p>
              
              <p className="text-lg font-medium text-foreground">
                Our mission: To help students learn more effectively by transforming any audio content—from live recordings to YouTube videos—into structured, accessible study materials through the power of AI.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
